import { DetailAction } from '../../detail/actions/DetailAction';
import { VodApi } from '../../../api/VodApi';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';
import { Backend } from '../../../api/Backend';
import { CmsFilterCallback, CmsFilterData } from './CmsFilterTypes';
import { OptionData } from '../../../components/option/OptionData';

export class YearCmsFilterAction extends DetailAction {
  private filter: CmsFilterData;
  private _callback: CmsFilterCallback;

  constructor(backend: Backend, filter: CmsFilterData, callback: CmsFilterCallback) {
    super(backend);
    this.filter = filter;
    this._callback = callback;
  }

  override doAction() {
    const filter = {
      catalogId: this._backend.deviceProfile?.profile.catalog,
      tag: this.filter.category ? this.filter.category.value : undefined,
    };
    VodApi.productionYears(this._backend, filter).then(data => {
      const options = data.map(year => ({ text: `${year}`, value: year })).sort((a, b) => b.text.localeCompare(a.text));
      this.owner?.fireAncestors('$openDialog', {
        type: SelectOptionDialog,
        params: {
          backend: this._backend,
          options: options,
          onSuccess: (val: OptionData) => {
            this.optionSelected(val);
          },
          onCancelled: this.hideOptions.bind(this),
        },
      });
    });
  }

  optionSelected(option: OptionData) {
    this.filter.year = option;
    this._callback(this.filter);
    this.hideOptions();
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }
}
